/**
 * @vuepress
 * ---
 * title: MinialSinisterTransformer
 * ---
 */

import Transformer from '../transformer'
import { MinimalCustomer } from '@/transformers/customers'
import { MinimalCatalog } from '@/transformers/catalogs'
import { parentPrefixTransformer, auroraUserFullName } from '@/transformers/utils'
import { displayDay } from '@/utils/moment'

/**
 * @class MinialSinisterTransformer
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 */

class MinialSinisterTransformer extends Transformer {
  /**
   * Agregar más campos si es necesario
   */
  static fetch({
    eco_user: ecoUser = {}, zone = {}, customer = {}, sinister_number: sinisterNumber, slug, assignment_date: assignmentDate
  }) {
    return {
      slug,
      sinisterNumber,
      assignmentDate: displayDay(assignmentDate),
      ecoUser: auroraUserFullName(ecoUser),
      ...parentPrefixTransformer('zone', MinimalCatalog.fetch(zone)),
      ...parentPrefixTransformer('customer', MinimalCustomer.fetch(customer))
    }
  }

  static searchFetch({
    id, slug, repport_number: reportNumber, folio, sinister_number: sinisterNumber, zone_slug: zoneSlug, udn
  }) {
    return {
      id,
      slug,
      folio,
      reportNumber,
      sinisterNumber,
      zoneSlug,
      udn
    }
  }
}
export default MinialSinisterTransformer
